export const groupByKey = <T>(items: T[], getKey: (item: T) => string): T[][] => {
  if (!items?.length) return [];

  const groupByKeyMap: Record<string, T[]> = {};

  items.forEach(item => {
    const key = getKey(item);
    if (!groupByKeyMap[key]) groupByKeyMap[key] = [];
    groupByKeyMap[key].push(item);
  });

  return Object.values(groupByKeyMap);
};
